import Home from "../Pages/Home";
import Products from "../Pages/Products";
import ProductDetails from "../Pages/ProductDetails";
import Inquiry from "../Pages/Inquiry";
import ContactUs from "../Pages/ContactUs";
import AboutUs from "../Pages/AboutUs";

// routes.js
const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Home /> },
  { path: "/about", element: <AboutUs /> },
  { path: "/products/:slug?/:search_query?", element: <Products /> },
  { path: "/product/:slug?", element: <ProductDetails /> },
  { path: "/inquiry/:slug?", element: <Inquiry /> },
  { path: "/contact", element: <ContactUs /> },
];

export default routes;